module.exports = __webpack_public_path__ + "static/img/qianyue4.4f4c7e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/qianyue4.png
// module id = UpWV
// module chunks = 1